module.exports = __webpack_public_path__ + "img/logo-footer.200e1b00.svg";